import * as React from "react"
import { Dispatch, SetStateAction } from "react"

interface WorkingPeopleProps {
  peopleSelectedOption: { title: string } | undefined
  setPeopleSelectedOption: Dispatch<
    SetStateAction<{ title: string } | undefined>
  >
}
export const WorkingPeople = ({
  peopleSelectedOption,
  setPeopleSelectedOption,
}: WorkingPeopleProps) => {
  const data = [
    {
      title: "How many people work for your business?",
      options: [
        {
          title: "Just me",
        },
        {
          title: "2 - 10",
        },
        {
          title: "11 - 50",
        },
        {
          title: "51 - 100",
        },
        {
          title: "500+",
        },
      ],
    },
  ]
  return (
    <>
      <div className="mt-10 pt-10 container mx-auto">
        <div className="flex gap-1 justify-center">
          <h2 className="text-black lg:text-3xl text-xl font-bold text-center">
            {data[0].title}
          </h2>
          <p className="pt-2 text-black"> (Optional)</p>
        </div>
        <div className="flex lg:gap-8 mx-2 gap-2 items-center mt-10">
          {data[0].options.map((option, index) => (
            <div
              key={index}
              className={`bg-real-time-options hover:border-[#7B68EC] cursor-pointer w-1/5 flex flex-col text-center items-center lg:py-4 py-2 lg:rounded-2xl rounded-lg justify-center ${
                peopleSelectedOption?.title === option.title
                  ? " border-none bg-input"
                  : ""
              }`}
              onClick={() =>
                setPeopleSelectedOption(
                  peopleSelectedOption?.title === option.title
                    ? undefined
                    : option
                )
              }
            >
              <p
                className={`lg:text-lg font-semibold text-xs ${
                  peopleSelectedOption?.title === option.title
                    ? " text-[#7B68EC]"
                    : " text-black"
                }`}
              >
                {option.title}
              </p>
            </div>
          ))}
        </div>
      </div>
    </>
  )
}
